export default __webpack_public_path__ + "static/media/closet3.a8f7fc94.jpg";